var map = {
	"./hasodaisuhi1.png": 5592,
	"./hasodaisuhi2.png": 8803,
	"./hasodaisuhi3.png": 4698,
	"./hasodaisuhi4.png": 8469,
	"./hasodaisuhi5.png": 2556,
	"./hasodaisuhi6.png": 5207,
	"./hasodaisuhi7.png": 2718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8994;